import React, { useState, createContext, useContext } from 'react';
export type IntakeData = {
  // Step 2
  contactName: string;
  contactRole: string;
  contactEmail: string;
  contactPhone: string;
  contactMethod: string;
  bestTime: string;
  isOwner: string;
  isDecisionMaker: string;
  multipleOwners: string;
  owners: Array<{
    id: string;
    name: string;
    role: string;
    email: string;
    phone: string;
    involvement: string;
    decisionRole: string;
  }>;
  // Step 3
  showTeamOnWebsite: string;
  teamHasPhotos: string;
  teamMembers: Array<{
    id: string;
    name: string;
    role: string;
    department: string;
    bio: string;
    email: string;
    phone: string;
    linkedin: string;
    showOnSite: boolean;
    photo: string;
    expertise: string;
    sortOrder: string;
  }>;
  // Step 4
  companyName: string;
  tradeName: string;
  legalStructure: string;
  cocNumber: string;
  vatNumber: string;
  foundingYear: string;
  mainAddress: string;
  mainStreet: string;
  mainPostcode: string;
  mainCity: string;
  mainProvince: string;
  mainCountry: string;
  postalAddress: string;
  companyPhone: string;
  companyEmail: string;
  existingWebsiteUrl: string;
  socialLinks: string;
  industry: string;
  companyDescription: string;
  activeRegion: string;
  reach: string;
  websiteLanguages: string;
  multipleLocations: string;
  locationStrategy: string;
  locations: Array<{
    id: string;
    name: string;
    street: string;
    postcode: string;
    city: string;
    province: string;
    country: string;
    phone: string;
    email: string;
    hours: string;
    showOnWebsite: string;
    needsPage: boolean;
    services: string;
  }>;
  // Step 5
  whoAreYou: string;
  howStarted: string;
  services: Array<{
    id: string;
    name: string;
    description: string;
  }>;
  difference: string;
  coreValues: string;
  communicate: string;
  companyFeel: string[];
  companyFeelOther: string;
  mission: string;
  vision: string;
  whyChooseUs: string;
  mustInclude: string;
  mustAvoid: string;
  idealWebsiteDescription: string;
  // Step 6
  hasLegalDocs: string;
  legalDocsApproach: string;
  legalDocsList: string[];
  legalDocsNeeded: string[];
  legalDocs: Record<string, {
    file: string;
    text: string;
    status: 'uploaded' | 'missing' | 'later' | '';
  }>;
  processData: string;
  hasForms: string;
  hasNewsletter: string;
  hasAnalytics: string;
  needsCookieBanner: string;
  industryRequirements: string;
  needsLegalHelp: string;
  // Step 7
  hasIdentity: string;
  brandingAssets: Record<string, {
    file: string;
    status: 'uploaded' | 'missing' | 'later' | '';
  }>;
  staySame: string;
  improve: string;
  preferredColors: Array<{
    hex: string;
    name: string;
  }>;
  dislikedColors: string;
  visualStyle: string;
  logoIdea: string;
  logoIdeas: string;
  logoSketch: string;
  logoSketchUpload: string;
  idealLogo: string;
  logoType: string;
  symbols: string;
  examples: string;
  fontStyle: string;
  typographyIdeas: string;
  typographyChoice: string;
  iconStyle: string;
  brandFeel: string[];
  // Step 8
  mainGoal: string;
  mainGoalOther: string;
  visitorAction: string;
  targetAudience: string;
  inspirationWebsites: string;
  desiredImpression: string;
  businessProblem: string;
  betterThanCurrent: string;
  ctas: string;
  kpis: string;
  // Step 9
  websiteType: string;
  features: string[];
  needsPortal: string;
  portalDetails: string;
  productManagement: string;
  userRoles: string;
  // Step 10
  neededPages: string[];
  customPages: string[];
  customPageOther: string;
  mustIncludePages: string;
  migratePages: string;
  disappearPages: string;
  mostImportantPage: string;
  // Ecommerce
  numProducts: string;
  categories: string;
  productVariations: string;
  productType: string;
  stockManagement: string;
  shippingMethods: string;
  paymentProviders: string;
  accountArea: string;
  wishlist: string;
  reviews: string;
  upsells: string;
  erpIntegration: string;
  // Portal
  portalVisibility: string;
  portalUploads: string;
  portalDashboard: string;
  portalStatuses: string;
  portalNotifications: string;
  portalSystemConnection: string;
  // Booking
  bookingItems: string;
  timeslots: string;
  multipleStaff: string;
  confirmationEmails: string;
  advancePayment: string;
  calendarConnection: string;
  // Recruitment
  vacancyArchive: string;
  vacancyFilters: string;
  applicationForm: string;
  cvUpload: string;
  vacancyCategories: string;
  vacancyLocations: string;
  autoPlacement: string;
  // Step 11
  existingContent: string[];
  createContent: string[];
  toneOfVoice: string;
  // Step 12
  hasWebsite: string;
  currentCms: string;
  domainOwned: string;
  domainName: string;
  domainHost: string;
  domainManagement: string;
  domainThirdParty: string;
  desiredDomains: string[];
  websiteOfflineAcceptable: string;
  hostingActive: string;
  emailsLinked: string;
  existingAnalytics: string;
  existingPixels: string;
  integrations: string;
  manageContent: string;
  needsTraining: string;
  multipleAdmins: string;
  // Step 13
  seoServices: string;
  seoRegions: string;
  seoSearchTerms: string;
  seoCompetitors: string;
  seoKeywordResearch: string;
  seoBlogposts: string;
  seoBlogFrequency: string;
  seoGoogleBusiness: string;
  seoGoogleBusinessTasks: string[];
  seoAppleBusiness: string;
  seoAppleBusinessTasks: string[];
  seoActiveUpdates: string;
  seoSilo: string;
  seoSiloPackage: string;
  seoSiloThemes: string;
  seoSiloRegions: string;
  seoAnalysis: string;
  seoHeatmapsUrgency: string;
  seoABTestingUrgency: string;
  seoReviews: string;
  seoTraining: string;
  seoGoogleAds: string;
  seoSocialAds: string[];
  needsBlogs: string;
  needsLeadGen: string;
  needsTools: string;
  needsCampaigns: string;
  // Step 14
  launchDate: string;
  hardDeadline: string;
  deadlineReason: string;
  feedbackGivers: string;
  stakeholdersCount: string;
  feedbackSpeed: string;
  remarks: string;
  extraNotes: string;
};
const defaultData: IntakeData = {
  contactName: '',
  contactRole: '',
  contactEmail: '',
  contactPhone: '',
  contactMethod: '',
  bestTime: '',
  isOwner: '',
  isDecisionMaker: '',
  multipleOwners: '',
  owners: [],
  showTeamOnWebsite: '',
  teamHasPhotos: '',
  teamMembers: [],
  companyName: '',
  tradeName: '',
  legalStructure: '',
  cocNumber: '',
  vatNumber: '',
  foundingYear: '',
  mainAddress: '',
  mainStreet: '',
  mainPostcode: '',
  mainCity: '',
  mainProvince: '',
  mainCountry: 'Nederland',
  postalAddress: '',
  companyPhone: '',
  companyEmail: '',
  existingWebsiteUrl: '',
  socialLinks: '',
  industry: '',
  companyDescription: '',
  activeRegion: '',
  reach: '',
  websiteLanguages: '',
  multipleLocations: '',
  locationStrategy: '',
  locations: [],
  whoAreYou: '',
  howStarted: '',
  services: [],
  difference: '',
  coreValues: '',
  communicate: '',
  companyFeel: [],
  companyFeelOther: '',
  mission: '',
  vision: '',
  whyChooseUs: '',
  mustInclude: '',
  mustAvoid: '',
  idealWebsiteDescription: '',
  hasLegalDocs: '',
  legalDocsApproach: '',
  legalDocsList: [],
  legalDocsNeeded: [],
  legalDocs: {},
  processData: '',
  hasForms: '',
  hasNewsletter: '',
  hasAnalytics: '',
  needsCookieBanner: '',
  industryRequirements: '',
  needsLegalHelp: '',
  hasIdentity: '',
  brandingAssets: {},
  staySame: '',
  improve: '',
  preferredColors: [],
  dislikedColors: '',
  visualStyle: '',
  logoIdea: '',
  logoIdeas: '',
  logoSketch: '',
  logoSketchUpload: '',
  idealLogo: '',
  logoType: '',
  symbols: '',
  examples: '',
  fontStyle: '',
  typographyIdeas: '',
  typographyChoice: '',
  iconStyle: '',
  brandFeel: [],
  mainGoal: '',
  mainGoalOther: '',
  visitorAction: '',
  targetAudience: '',
  inspirationWebsites: '',
  desiredImpression: '',
  businessProblem: '',
  betterThanCurrent: '',
  ctas: '',
  kpis: '',
  websiteType: '',
  features: [],
  needsPortal: '',
  portalDetails: '',
  productManagement: '',
  userRoles: '',
  neededPages: [],
  customPages: [],
  customPageOther: '',
  mustIncludePages: '',
  migratePages: '',
  disappearPages: '',
  mostImportantPage: '',
  numProducts: '',
  categories: '',
  productVariations: '',
  productType: '',
  stockManagement: '',
  shippingMethods: '',
  paymentProviders: '',
  accountArea: '',
  wishlist: '',
  reviews: '',
  upsells: '',
  erpIntegration: '',
  portalVisibility: '',
  portalUploads: '',
  portalDashboard: '',
  portalStatuses: '',
  portalNotifications: '',
  portalSystemConnection: '',
  bookingItems: '',
  timeslots: '',
  multipleStaff: '',
  confirmationEmails: '',
  advancePayment: '',
  calendarConnection: '',
  vacancyArchive: '',
  vacancyFilters: '',
  applicationForm: '',
  cvUpload: '',
  vacancyCategories: '',
  vacancyLocations: '',
  autoPlacement: '',
  existingContent: [],
  createContent: [],
  toneOfVoice: '',
  hasWebsite: '',
  currentCms: '',
  domainOwned: '',
  domainName: '',
  domainHost: '',
  domainManagement: '',
  domainThirdParty: '',
  desiredDomains: [],
  websiteOfflineAcceptable: '',
  hostingActive: '',
  emailsLinked: '',
  existingAnalytics: '',
  existingPixels: '',
  integrations: '',
  manageContent: '',
  needsTraining: '',
  multipleAdmins: '',
  seoServices: '',
  seoRegions: '',
  seoSearchTerms: '',
  seoCompetitors: '',
  seoKeywordResearch: '',
  seoBlogposts: '',
  seoBlogFrequency: '',
  seoGoogleBusiness: '',
  seoGoogleBusinessTasks: [],
  seoAppleBusiness: '',
  seoAppleBusinessTasks: [],
  seoActiveUpdates: '',
  seoSilo: '',
  seoSiloPackage: '',
  seoSiloThemes: '',
  seoSiloRegions: '',
  seoAnalysis: '',
  seoHeatmapsUrgency: '',
  seoABTestingUrgency: '',
  seoReviews: '',
  seoTraining: '',
  seoGoogleAds: '',
  seoSocialAds: [],
  needsBlogs: '',
  needsLeadGen: '',
  needsTools: '',
  needsCampaigns: '',
  launchDate: '',
  hardDeadline: '',
  deadlineReason: '',
  feedbackGivers: '',
  stakeholdersCount: '',
  feedbackSpeed: '',
  remarks: '',
  extraNotes: ''
};
interface IntakeContextType {
  data: IntakeData;
  updateData: (fields: Partial<IntakeData>) => void;
  currentStep: number;
  setCurrentStep: (step: number) => void;
  totalSteps: number;
}
const IntakeContext = createContext<IntakeContextType | undefined>(undefined);
export function IntakeProvider({
  children
}: {
  children: ReactNode;
}) {
  const [data, setData] = useState<IntakeData>(defaultData);
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 15;
  const updateData = (fields: Partial<IntakeData>) => {
    setData(prev => ({
      ...prev,
      ...fields
    }));
  };
  return <IntakeContext.Provider value={{
    data,
    updateData,
    currentStep,
    setCurrentStep,
    totalSteps
  }} data-id="element-702">
      {children}
    </IntakeContext.Provider>;
}
export function useIntake() {
  const context = useContext(IntakeContext);
  if (context === undefined) {
    throw new Error('useIntake must be used within an IntakeProvider');
  }
  return context;
}